import { render, staticRenderFns } from "./AppointDistribution.vue?vue&type=template&id=589787b0&scoped=true"
import script from "./AppointDistribution.vue?vue&type=script&lang=js"
export * from "./AppointDistribution.vue?vue&type=script&lang=js"
import style0 from "./AppointDistribution.vue?vue&type=style&index=0&id=589787b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589787b0",
  null
  
)

export default component.exports